<footer id="footer" class="footer">
    <div class="ca-footer row hide-on-sm-above mx-0">
        <div class="footer-text col-6">
            <p class="left-align">{{priceStated}}</p>
        </div>
        <div class="footer-text col-6">
            <p class="right-align">{{maxisCopyright}}</p>
        </div>
        <div class="footer-text col-12">
            <p style="margin-bottom: 0">{{redressYourComplaints}}</p>
        </div>
    </div>

    <div class="ca-footer row hide-on-sm-below mx-0">
        <div class="footer-text">
            <p>{{priceStated}}</p>
            <p>{{redressYourComplaints}}</p>
            <p style="padding-top: 28px; margin-bottom: 0">{{maxisCopyright}}</p>
        </div>
    </div>
</footer>